$shm_hitalama_benchmarks_client_frame $mol_view
	client $shm_hitalama_benchmarks_client
	dom_name \iframe
	uri \
	sub /
	attr *
		^
		src <= uri
	minimal_height 600
	style *
		^
		width \100%
		height \600px
